import { CouponData } from "./CouponType";
import { TimeConverter } from "../../utils/TimeConverter";
import { DateConverter } from "../../utils/DateConverter";

interface CouponInvalidProps {
  data: CouponData[];
}

const CouponInvalid: React.FC<CouponInvalidProps> = ({ data }) => {
  return (
    <>
      {data &&
        data.map((item) => (
          <tr key={item.coupon_name} className="segway_item_container">
            <td className="invalid_coupon_all_item">{item.coupon_name}</td>
            <td className="invalid_coupon_all_item">{item.coupon_info}</td>
            <td className="invalid_coupon_all_item">
              {item.coupon_discount}
              {item.coupon_type}
              引き
            </td>
            <td className="invalid_coupon_all_item">{item.get_limit}</td>
            <td className="invalid_coupon_all_item">{item.get_count}</td>
            <td className="invalid_coupon_all_item">
              {DateConverter(item.start_date)}
            </td>
            <td className="invalid_coupon_all_item">
              {DateConverter(item.expiry)}
            </td>
            <td className="invalid_coupon_all_item">{item.is_reusable}</td>
            <td className="invalid_coupon_all_item">{item.is_single_use}</td>
            <td className="invalid_coupon_all_item">{item.is_weekend}</td>
            {/* <td className="invalid_coupon_all_item">{item.time_limit}</td> */}
            <td className="invalid_coupon_all_item">
              {item.available_start_time === "なし"
                ? "なし"
                : TimeConverter(item.available_start_time, {
                    timezone: "Asia/Tokyo",
                  })}
            </td>
            <td className="invalid_coupon_all_item">
              {item.available_end_time === "なし"
                ? "なし"
                : TimeConverter(item.available_end_time, {
                    timezone: "Asia/Tokyo",
                  })}
            </td>
          </tr>
        ))}
    </>
  );
};

export default CouponInvalid;
